import Paper from '@mui/material/Paper'

export default function Panel({ children, centered, sx, ...props }) {
  sx = {
    borderRadius: {
      xs: 0,
      sm: 0.5,
    },
    my: {
      xs: 0,
      sm: 4,
    },
    mx: {
      xs: 0,
      sm: 4,
    },
    ...sx,
  }
  if (centered) {
    sx = {
      ...sx,
      py: 4,
      width: '100%',
      maxWidth: 800,
      mx: 'auto',
      bgcolor: 'background.paper',
    }
  }
  return (
    <Paper sx={sx} {...props}>
      {children}
    </Paper>
  )
}
